import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("growthspace", {
  list: () => ({
    queryKey: ["list-growthspaces"],
  }),
})
